import * as yup from "yup";

export default function schema(){
    const schema = yup.object({
        code: yup.string().required("You must enter the verification code to continue!")
                .min(6, "Verification code should be exactly 6 characters")
                .max(6, "Verification code should be exactly 6 characters")
    });
    return schema;
}
